import headerCss from "@src/assets/_libs/layout/_l-header.module.scss"
import wrapperCss from "@src/assets/_libs/layout/_l-wrapper.module.scss"
import { pageConst } from "@src/constants/pageConst";

/**
 * ヘッダ用organisms
 * ヘッダの表示
 * @returns {JSX.Element}
 * @param props
 */
export function Header() {
  return (
    <header className={headerCss["l-global-header"]}>
      <div className={wrapperCss["l-wrapper"]}>
        <div className="l-logo">
          <a href={pageConst.home.href}><img src={pageConst.home.primaryIcon} alt={pageConst.home.iconAlt} /></a>
        </div>
      </div>
    </header>
  );
}
